class ConstPedidoOrigenCreacion {
    BACKOFFICE = 1;
    FRONTOFFICE = 2;
    EXPRESSFORM = 3;
    RECOMMENDATION = 5;

    get(id) {
        switch (id) {
            case this.BACKOFFICE:
                return "backoffice";
            case this.FRONTOFFICE:
                return "frontoffice";
            case this.EXPRESSFORM:
                return "express_form";
            case this.RECOMMENDATION:
                return "recommendation";
        }
    }

    getAll() {
        return [{
                id: this.BACKOFFICE,
                value: "backoffice"
            },
            {
                id: this.FRONTOFFICE,
                value: "frontoffice"
            },
            {
                id: this.EXPRESSFORM,
                value: "express_form"
            },
            {
                id: this.RECOMMENDATION,
                value: "recommendation"
            }
        ];
    }

    constructor(obj = {}) {
        Object.assign(this, obj);
    }
}

module.exports = ConstPedidoOrigenCreacion;